export enum FontWeight {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Regular = 'normal',
  Medium = 500,
  SemiBold = 600,
  Bold = 'bold',
  ExtraBold = 800,
  Black = 900,
}

export enum FontStyle {
  Normal = 'normal',
  Italic = 'italic',
  Oblique = 'oblique',
}

// sizes in rem (1rem = base font size)
export enum FontSize {
  Size_1 = 0.875,
  Size_2 = 1.1429,
  Size_3 = 1.429,
  Size_4 = 1.25,
  Size_5 = 1.334,
  Size_6 = 2.125,
  Size_7 = 3,
  Size_8 = 3.75,
  Size_9 = 4.2857,
}

export enum FontFormat {
  WOFF = 'woff',
  WOFF2 = 'woff2',
  EOT = 'embedded-opentype',
  TTF = 'truetype',
}

export interface IFontFaceFallbacks {
  src: string;
}

export interface IFontFace {
  fontFamily: string;
  fontStyle: FontStyle;
  fontWeight: FontWeight;
  fallbacks: Array<IFontFaceFallbacks>;
  fontDisplay: string;
  unicodeRange?: string;
}

export const fontFamilyName = 'Picsart-Fonts';

export const systemFonts =
  '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Helvetica, Arabic, sans-serif';

export const defaultFonts = `${fontFamilyName}, ${systemFonts}`;
